import {
  Component,
  ViewChild,
  OnInit,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../app.reducers';
import { ImportRequest } from '../../shared/models';
import { CustomValidators } from '../../../../shared';

@Component({
  selector: 'sp-admin-data-import-request-export-diff',
  templateUrl: './admin-data-import-request-export-diff.component.html',
  styleUrls: ['./admin-data-import-request-export-diff.component.scss'],
  standalone: false
})
export class AdminDataImportRequestExportDiffComponent implements OnInit {

  @ViewChild(ModalDirective, { static: true }) public bsModal: ModalDirective;
  @Input() importRequest: ImportRequest;
  @Output() confirm: EventEmitter<number> = new EventEmitter<number>();
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  formGroup: UntypedFormGroup = new UntypedFormGroup({});

  constructor(private store: Store<AppState>,
    private fb: UntypedFormBuilder) {}

  ngOnInit() {
    this.initForm();
  }

  private initForm() {
    this.formGroup = this.fb.group({
      fiscalYear: this.fb.control('', [Validators.required, CustomValidators.notEmptyStringValidator]),
    });
  }

  onCancel() {
    this.cancel.next();
    this.bsModal.hide();
  }

  onConfirm() {
    this.confirm.next(this.formGroup.value.fiscalYear);
    this.bsModal.hide();
  }

  show() {
    this.bsModal.show();
  }
}
